import React, { useState } from 'react';
import useData from '../../hooks/useData';
import GlassButton from '../ui/Button';
import InputField from '../ui/InputField';
import { AddIcon, DeleteIcon, EditIcon, SaveIcon } from '../ui/Icons';

const SenderProfileManagerModal = ({ onClose }) => {
    const { senderProfiles, handleSaveSenderProfile, handleDeleteSenderProfile } = useData();
    const [profile, setProfile] = useState({ name: '', companyName: '', email: '', phone: '', address: '' });
    const [editingId, setEditingId] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile(p => ({ ...p, [name]: value }));
    };

    const handleSave = async () => {
        if (!profile.name || !profile.companyName) return;
        
        if (editingId) {
            await handleSaveSenderProfile({ id: editingId, ...profile });
            setEditingId(null);
        } else {
            await handleSaveSenderProfile(profile);
        }
        setProfile({ name: '', companyName: '', email: '', phone: '', address: '' });
    };

    const handleEdit = (p) => {
        setEditingId(p.id);
        setProfile({ name: p.name, companyName: p.companyName, email: p.email, phone: p.phone, address: p.address });
    };

    return (
        <div className="p-6 text-white max-w-3xl w-full">
            <h2 className="text-2xl font-bold mb-4">Gerenciar Perfis de Remetente</h2>
            <div className="space-y-2 max-h-52 overflow-y-auto pr-2 mb-4">
                {senderProfiles.map(p => (
                    <div key={p.id} className="flex justify-between items-center bg-white/5 p-3 rounded-lg">
                        <div>
                            <p className="font-semibold">{p.name} <span className="text-sm text-gray-400">({p.companyName})</span></p>
                        </div>
                        <div className="flex items-center gap-2">
                            <button onClick={() => handleEdit(p)} className="p-1 text-blue-300 hover:text-white"><EditIcon size={16}/></button>
                            <button onClick={() => handleDeleteSenderProfile(p.id)} className="p-1 text-red-400 hover:text-white"><DeleteIcon size={16}/></button>
                        </div>
                    </div>
                ))}
            </div>
            <div className="bg-white/10 p-4 rounded-lg space-y-4">
                <h3 className="font-semibold text-lg">{editingId ? 'Editando Perfil' : 'Adicionar Novo Perfil'}</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <InputField label="Nome do Perfil" name="name" placeholder="Ex: Pessoal, Minha Empresa" value={profile.name} onChange={handleChange} />
                    <InputField label="Seu Nome / Empresa" name="companyName" placeholder="O que aparece no orçamento" value={profile.companyName} onChange={handleChange} />
                    <InputField label="Email" name="email" type="email" value={profile.email} onChange={handleChange} />
                    <InputField label="Telefone" name="phone" value={profile.phone} onChange={handleChange} />
                    <div className="md:col-span-2">
                        <InputField label="Endereço" name="address" value={profile.address} onChange={handleChange} />
                    </div>
                </div>
                <div className="flex justify-end">
                    <GlassButton onClick={handleSave} className="!bg-indigo-500">
                        {editingId ? <SaveIcon /> : <AddIcon />}
                        <span className="ml-2">{editingId ? 'Salvar Alterações' : 'Adicionar Perfil'}</span>
                    </GlassButton>
                </div>
            </div>
            <div className="mt-6 text-right">
                <GlassButton onClick={onClose}>Fechar</GlassButton>
            </div>
        </div>
    );
};

export default SenderProfileManagerModal;